import React from "react";
import "../styles/HistoryTable.css";

export default function HistoryTable({ downloadHistory }) {
  return (
    <div className="history-section">
      <h3>Download History</h3>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Content Address</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {downloadHistory.map((entry) => (
            <tr key={entry.id}>
              <td>{entry.id}</td>
              <td>
                <a
                  href={entry.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link"
                >
                  ⬇ View File
                </a>
              </td>
              <td>
                <span className="status success">{entry.status}</span>
              </td>
              <td>{new Date(entry.created_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
